
export abstract class EntityDates {
	createdAt = new Date();
	updatedAt = new Date();
	deletedAt!: Date;
}
